import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Viewer } from "../../../../../widgets/Viewer";
import { withRouter } from 'react-router-dom';
import { Spinner } from '@blueprintjs/core';

import { loadRecipientApps, deleteRecipientApp } from '../../../../../../redux/actions/recipientApp.actions';

const RecipientAppRow = props => {
    return (
        <tr onClick={() => props.editRow(props.recipientApp)}>
            <td>{moment(props.recipientApp.application_date).format('ddd, MMM Do, YYYY')}</td>
            <td>{props.recipientApp.notes}</td>
            <td onClick={e => e.stopPropagation()}>
                <Viewer src={props.recipientApp.image || props.recipientApp.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
            </td>
            <td className="action-row">
                <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => props.deleteRow({ recipientApp: props.recipientApp, event })}>Delete</div>
            </td>
        </tr>
    );
};

class RecipientApps extends Component {
    async componentDidMount() {
        const { clientId, progressId } = this.props.match.params;
        await this.props.loadRecipientApps({ recipientId: clientId, progressId });
    }
    openRecipientAppsModal = () => {
        const event = new CustomEvent('open-recipient-app-modal', {
            detail: {
                ...this.props.match.params,
                recipientId: this.props.match.params.clientId
            }
        });
        window.dispatchEvent(event);
    }
    editRow = (recipientApp) => {
        const { clientId, progressId } = this.props.match.params;
        const event = new CustomEvent('open-recipient-app-modal', {
            detail: {
                ...recipientApp,
                recipientId: clientId,
                progressId
            }
        });
        window.dispatchEvent(event);
    }
    deleteRow = ({ event, recipientApp }) => {
        event.preventDefault();
        event.stopPropagation();
        const { clientId, progressId } = this.props.match.params;
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete this application?`,
                onDelete: () => {
                    this.props.deleteRecipientApp({ recipientId: clientId, progressId, appId: recipientApp.id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { recipientApps } = this.props;
        return (
            <div className="panel-recipientApps panel-content">
                { this.props.allLoading ?
                    <div className="spinner-container">
                        <Spinner large />
                    </div> :
                    recipientApps.length ?
                        <table className="general-table pt-html-table pt-interactive">
                            <thead>
                                <tr>
                                    <th>Application Date</th>
                                    <th>Notes</th>
                                    <th>Preview</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                { recipientApps.map((recipientApp, i) => (
                                    <RecipientAppRow key={i}
                                        recipientApp={recipientApp}
                                        editRow={this.editRow}
                                        deleteRow={this.deleteRow} />
                                ))}
                            </tbody>
                        </table> :
                        <div className="intro">
                            <div className="intro-text">
                                No applications. Start by <span className="link" onClick={this.openRecipientAppsModal} >adding one</span>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    recipientApps: state.recipientApp.recipientApps,
    recipientAppsById: state.recipientApp.recipientAppsById,
    allLoading: state.recipientApp.allLoading
});

const mapDispatchToProps = {
    loadRecipientApps,
    deleteRecipientApp
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecipientApps));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/progress-panels/RecipientApps.jsx